import { Box, Button, Container, Link, Typography } from "@mui/material";
import { ChevronRight } from "@mui/icons-material";
import { ProductContext } from "./provider.js";
import { useTranslation } from "next-i18next";
import NextLink from "next/link";
import React from "react";
export const Preparation = () => {
    const { t } = useTranslation("c-product");
    const { colors, edition } = React.useContext(ProductContext);
    return (React.createElement(Box, { component: "section", id: "preparation", sx: {
            backgroundColor: colors.accent1,
            boxShadow: "sectionVertical",
            mt: { xs: 4, sm: 4 },
            position: "relative",
            zIndex: 25,
        } },
        React.createElement(Container, { maxWidth: "xl", sx: { pt: { xs: 6, sm: 8, md: 10 }, pb: { xs: 6, sm: 10, md: 14 } } },
            React.createElement(Typography, { variant: "h2", sx: { pb: { xs: 3, sm: 3 } } }, edition === "online"
                ? t("preparation-headline-online", "Online-Krimidinner starten")
                : t("preparation-headline-print", "Vorbereitung")),
            React.createElement(Typography, { variant: "body1", sx: { maxWidth: "70ch" } }, edition === "online"
                ? t("preparation-online-copy-1", "Du erhältst den Zugangscode für dein Culinario Mortale® Online-Krimidinner direkt im Anschluss an deine Bezahlung per E-Mail. Bitte überprüfe im Zweifelsfall auch deinen Spam-Filter. Mit dem Code aus der E-Mail kannst du direkt loslegen.")
                : t("preparation-print-copy-1", "Mit dem Zugangscode aus deinem Culinario Mortale® Krimidinner kannst du alle Rollenbeschreibungen bequem als PDF-Datei herunterladen und deinen Gästen schicken. Das macht die Vorbereitung besonders einfach.")),
            React.createElement(Button, { LinkComponent: edition === "online" ? Link : NextLink, href: edition === "online"
                    ? t("url-online-game", "https://online.culinario-mortale.de")
                    : t("url-preparation", "/vorbereitung"), endIcon: React.createElement(ChevronRight, null), sx: { mt: 6, width: { xs: "100%", sm: "auto" } }, variant: "contained" }, edition === "online"
                ? t("preparation-online-button", "Jetzt loslegen")
                : t("preparation-print-button", "Vorbereitung starten")))));
};
//# sourceMappingURL=preparation.js.map